export default function openAdManager(router) {
    router.query.account = 'adManager';
    router.push(router);
}